<template>
	<div>
		<div style="padding: 8px" class="card-body" v-show="!hideInfos">
			<div style="line-height: 20px">
				{{ designativo.sigla }}
				<i
					:class="this.className"
					style="cursor: pointer"
					@click="alteraFavorito()"
				></i>
				<span
					style="cursor: pointer"
					class="hidden-doc"
					@click="hideDesignativo"
				>
					<strong>
						<i class="fa fa-times"></i>
					</strong>
				</span>
			</div>
		</div>
		<div
			class="card-footer btn-group"
			style="width: 100%"
			:style="{padding: hideInfos ? '0px' : '0px 4px 8px 4px'}"
		>
			<button
				class="btn btn-sm btn-primary"
				style="width: calc(33% - 3px); margin-left: 3px"
				@click="showModalMetar"
			>
				METAR/TAF
			</button>
			<button
				class="btn btn-sm btn-primary"
				style="width: calc(33% - 3px); margin-left: 3px"
				@click="showModalNotam"
			>
				NOTAM
			</button>
			<button
				class="btn btn-sm btn-primary"
				style="width: calc(33% - 3px); margin-left: 3px"
				@click="showModalRotaer"
			>
				ROTAER
			</button>
		</div>
		<modal ref="modalMetar">
			<div class="row">
				<div class="col-xs-12">
					<h4>
						METAR/TAF
						<button
							type="button"
							class="close"
							@click="$refs.modalMetar.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
					<small>METAR</small>
					<p>{{ metar | na }}</p>
					<hr />
					<small>TAF</small>
					<p>{{ taf | na }}</p>
				</div>
			</div>
		</modal>
		<modal ref="modalNotam">
			<div class="row">
				<div class="col-xs-12">
					<h4>
						NOTAM
						<button
							type="button"
							class="close"
							@click="$refs.modalNotam.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
					<div v-for="(item, index) in notam" :key="index">
						<div class="row">
							<div class="col-xs-12 form-group">
								<div
									style="float: left; font-size: 12px; margin-right: 10px"
									class="label"
									:class="{
										'label-success': item.ref == '',
										'label-info': item.ref != ''
									}"
								>
									{{ item.n }}
								</div>
								<div
									style="float: left; font-size: 12px; margin-right: 10px"
									class="label"
									:class="{
										'label-success': item.ref == '',
										'label-info': item.ref != ''
									}"
								>
									{{ item.ref == '' ? item.status : 'R' }}
								</div>
								<div
									style="float: left; font-size: 12px; margin-right: 10px"
									v-if="item.ref != '' && item.ref != null"
									class="label label-primary"
								>
									{{ item.ref }}
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12 form-group">
								<p class="text-justify" style="font-size: 12px">{{ item.e }}</p>
							</div>
						</div>
						<div class="row" v-if="item.f != '' && item.f != null">
							<div class="col-xs-12 form-group">
								<span style="margin-right: 20px">
									<i
										class="fa fa-fw fa-fw fa-sort-amount-desc"
										style="color: #2196f3"
									></i
									>{{ item.f }}
								</span>
								<span>
									<i
										class="fa fa-fw fa-sort-amount-desc fa-rotate-180"
										style="color: #2196f3"
									></i
									>{{ item.g }}
								</span>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12 form-group">
								<i
									style="color: #2196f3"
									class="fa fa-fw fa-calendar-o"
									aria-hidden="true"
								></i
								>{{ item.b | formataDataSubstring }} até
								{{ item.c | formataDataSubstring }}
							</div>
						</div>
						<div class="row" v-if="item.d != '' && item.d != null">
							<div class="col-xs-12 form-group">
								<i class="fa fa-fw fa-clock-o" style="color: #2196f3"></i>
								{{ item.d }}
							</div>
						</div>
						<hr />
					</div>
				</div>
			</div>
		</modal>
		<modal ref="modalRotaer">
			<div class="row" v-if="rotaer !== null">
				<div class="col-xs-12">
					<h4>
						ROTAER
						<button
							type="button"
							class="close"
							@click="$refs.modalRotaer.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
					<div class="row">
						<div class="col-xs-12">
							<div v-html="rotaer"></div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>
export default {
	props: {
		designativo: {
			type: Object,
			required: true
		},
		hideInfos: {
			type: Boolean,
			default: false
		}
	},

	created() {
		if (this.designativo.favorito == '1') {
			this.className = 'fa fa-star yellow'
		} else {
			this.className = 'fa fa-star-o'
		}
	},

	data() {
		return {
			apiKey: '1807502681',
			apiPass: 'e7119df3-cf96-11e7-a836-00505680c1b4',
			metar: null,
			taf: null,
			notam: [],
			rotaer: null,
			className: 'fa fa-star-o'
		}
	},
	methods: {
		hideDesignativo() {
			window.bus.$emit('hide-designativo', this.designativo)
		},
		getUrlApi() {
			return `https://aisweb.decea.mil.br/api/?apiKey=${this.apiKey}&apiPass=${this.apiPass}`
		},
		getMetar(callback) {
			let url =
				this.getUrlApi() + `&area=met&icaoCode=${this.designativo.sigla}`
			new Promise((resolve) => {
				this._httpGetExternal(
					url,
					(resposta) => {
						const metar = resposta.getElementsByTagName('metar')[0].textContent
						const taf = resposta.getElementsByTagName('taf')[0].textContent
						resolve({metar, taf})
					},
					'XML'
				)
			}).then((response) => {
				this.metar = response.metar
				this.taf = response.taf
				callback()
			})
		},
		getNotam(callback) {
			let url =
				this.getUrlApi() + `&area=notam&icaoCode=${this.designativo.sigla}`
			new Promise((resolve) => {
				this._httpGetExternal(
					url,
					(resposta) => {
						let notam = []
						let item = resposta.getElementsByTagName('item')
						const l = item.length
						for (var i = 0; i < l; i++) {
							let n = {}
							const tags = [
								'e',
								'id',
								'cod',
								'status',
								'ref',
								'cat',
								'tp',
								'dt',
								'n',
								'loc',
								'b',
								'c',
								'd',
								'f',
								'g',
								'nof',
								's',
								'geo',
								'aero',
								'cidade',
								'uf',
								'origem',
								'fir',
								'traffic',
								'purpose',
								'scope'
							]
							tags.forEach((tag) => {
								n[tag] = item[i].getElementsByTagName(tag)[0].textContent
							})
							notam.push(n)
						}
						resolve({notam})
					},
					'XML'
				)
			}).then((response) => {
				this.notam = response.notam
				callback()
			})
		},
		getRotaer(callback) {
			const self = this
			let url =
				this.getUrlApi() +
				`&area=rotaer&icaoCode=${this.designativo.sigla}&force=html`
			new Promise((resolve) => {
				this._httpGetExternal(
					url,
					(resposta) => {
						resolve({rotaer: resposta})
					},
					'HTML'
				)
			}).then((response) => {
				this.rotaer = response.rotaer
				callback()
			})
		},
		showModalMetar() {
			this.getMetar(() => {
				this.$refs.modalMetar.modalShow(40)
			})
		},
		showModalNotam() {
			this.getNotam(() => {
				this.$refs.modalNotam.modalShow(60)
			})
		},
		showModalRotaer() {
			this.getRotaer(() => {
				this.$refs.modalRotaer.modalShow(60)
			})
		},

		alteraFavorito() {
			if (this.className == 'fa fa-star yellow') {
				this.className = 'fa fa-star-o'
			} else {
				this.className = 'fa fa-star yellow'
			}
			this._axios(
				`/Fiscalizacao_rampa/altera_favorito/${this.designativo.sigla}`,
				'get',
				{
					callback: (retorno) => {
						if (retorno.status == 'sucesso') {
							if (retorno.favorito == '1') {
								this.className = 'fa fa-star yellow'
							} else {
								this.className = 'fa fa-star-o'
							}
							return
						}
					},
					finally: () => {
						bus.$emit('load-out')
					}
				}
			)
		}
	}
}
</script>
<style>
.rotaer {
	word-break: break-all;
}
.hidden-doc {
	float: right;
	font-size: 12px;
}

.yellow {
	color: #ffd700;
}
</style>